<template>
  <div
    id="demo-sections"
    ref="demo-sections"
    class="DemoSections h-full flex flex-col overflow-hidden"
    :style="{ height: dynamicHeight + 'px' }"
  >
    <div class="relative px-4 sm:px-8 pb-8 gap-4 flex flex-col">
      <div
        id="invisible-sections-list"
        class="absolute top-0 left-0 w-full px-4 sm:px-8 invisible opacity-0 pointer-events-none"
      >
        <SectionsList :list="invisibleSectionsList" />
      </div>

      <SectionsList :list="sectionsList" />

      <DemoSectionsLocked @show-more="() => (isAllSectionModalOpen = true)" />
    </div>

    <DemoAllSectionModal
      v-if="isAllSectionModalOpen"
      @close="() => (isAllSectionModalOpen = false)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import SectionsList from '@/components/Hub/Sections/SectionsList.vue'
import DemoSectionsLocked from '@/components/Demo/DemoSectionsLocked.vue'
import DemoAllSectionModal from '@/components/Demo/DemoAllSectionModal.vue'

export default {
  name: 'DemoSections',

  components: {
    SectionsList,
    DemoSectionsLocked,
    DemoAllSectionModal
  },

  provide() {
    return {
      isDemo: true,
      isStars: false
    }
  },

  data() {
    return {
      invisibleSectionsListHeight: 0,
      demoSectionsLockedContentHeight: 0,
      resizeObserver: null,
      isAllSectionModalOpen: false
    }
  },

  computed: {
    ...mapState('sections', ['sections']),

    invisibleSectionsList() {
      const basicsSection = structuredClone(this.sections.list).find(
        section => section.slug === 'basics'
      )

      basicsSection.topics = basicsSection.topics.slice(0, 3)

      return [basicsSection]
    },

    sectionsList() {
      let list = structuredClone(this.sections.list).filter(
        section => !['tutorial', 'playground'].includes(section.slug)
      )

      return list
    },

    dynamicHeight() {
      return (
        this.invisibleSectionsListHeight + this.demoSectionsLockedContentHeight
      )
    }
  },

  mounted() {
    this.setupResizeObserver()
  },

  beforeUnmount() {
    this.cleanupResizeObserver()
  },

  methods: {
    setupResizeObserver() {
      this.$nextTick(() => {
        const invisibleSectionsList = document.getElementById(
          'invisible-sections-list'
        )
        const demoSectionsLockedContent = document.getElementById(
          'demo-sections-locked-content'
        )

        if (invisibleSectionsList && demoSectionsLockedContent) {
          // Create ResizeObserver to watch for size changes
          this.resizeObserver = new ResizeObserver(() => {
            this.updateHeights()
          })

          // Start observing both elements
          this.resizeObserver.observe(invisibleSectionsList)
          this.resizeObserver.observe(demoSectionsLockedContent)

          // Initial height calculation
          this.updateHeights()
        }
      })
    },

    cleanupResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    },

    updateHeights() {
      this.$nextTick(() => {
        const invisibleSectionsList = document.getElementById(
          'invisible-sections-list'
        )
        const demoSectionsLockedContent = document.getElementById(
          'demo-sections-locked-content'
        )

        if (invisibleSectionsList) {
          this.invisibleSectionsListHeight = invisibleSectionsList.clientHeight
        }

        if (demoSectionsLockedContent) {
          this.demoSectionsLockedContentHeight =
            demoSectionsLockedContent.clientHeight
        }
      })
    }
  }
}
</script>

<style lang="scss">
.DemoSections {
  .hub-topics-list-item:nth-child(-n + 3) {
    transition: all 0.5s;
  }

  &:hover {
    .hub-topics-list-item:nth-child(-n + 3) {
      @apply ring-2 ring-yellow-500/50;
    }
  }
}
</style>
